import * as Yup from "yup";
import servicoValidator from "../../servicos/add-servicos/middlewares/servico.validator";

const servicosCsvValidator = Yup.array()
  .of(servicoValidator)
  .min(1, "Adicione ao menos um item")
  .required("Adicione ao menos um item");

export default servicosCsvValidator;
